import type { Dispatch } from "@reduxjs/toolkit";
// eslint-disable-next-line no-restricted-imports -- This file defines the typed hooks that should be used instead
import { useDispatch, useSelector } from "react-redux";

import { commonAppActions } from "./actions";
import { CommonAppActions, CommonAppState } from "./types";

/**
 * Pre-typed `useSelector` hook for use throughout the commons.
 * Uses Redux Toolkit's `.withTypes()` pattern for better type inference.
 * Knows about the full State shape including RTK slices.
 *
 * @example
 * const toasts = useCommonAppSelector(state => state.toasts.toasts);
 */
export const useCommonAppSelector = useSelector.withTypes<CommonAppState>();

/**
 * Pre-typed hook that provides both dispatch and all commons actions in one call.
 * Returns [dispatch, actions] tuple following useState pattern.
 *
 * @example
 * const [dispatch, actions] = useCommonAppDispatcher();
 * dispatch(actions.toasts.showToast({ title: "Hello" }));
 */
export const useCommonAppDispatcher = () => {
  const dispatch = useDispatch<Dispatch<CommonAppActions>>();
  return [dispatch, commonAppActions] as const;
};
